import { render } from "./info-form-v2.vue?vue&type=template&id=77e74834"
import script from "./info-form-v2.vue?vue&type=script&lang=js"
export * from "./info-form-v2.vue?vue&type=script&lang=js"

import "./info-form-v2.vue?vue&type=style&index=0&id=77e74834&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-form/info-form-v2.vue'],['render',render],['__file',"info-form-v2.vue"]])

export default __exports__